/* --- NEW: Play-on-scroll for Enhanced Video Module --- */
function setupVideoAutoplayOnScroll() {
    const videoHighlights = document.querySelectorAll('.ac-video-highlight');

    if (videoHighlights.length === 0) return;

    const observerOptions = {
        root: null, // observes intersections relative to the viewport
        rootMargin: '0px',
        threshold: 0.5 // trigger when 50% of the element is visible
    };

    const videoObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const iframe = entry.target.querySelector('iframe');
                if (iframe) {
                    // To autoplay a YouTube video, we add specific parameters to its src
                    // Muting is essential for autoplay to work in most modern browsers.
                    let currentSrc = iframe.src;
                    if (currentSrc.indexOf('autoplay') === -1) {
                       const separator = currentSrc.indexOf('?') === -1 ? '?' : '&';
                       iframe.src = `${currentSrc}${separator}autoplay=1&mute=1`;
                    }
                    
                    // Stop observing this element once we've triggered it
                    observer.unobserve(entry.target);
                }
            }
        });
    }, observerOptions);

    videoHighlights.forEach(video => {
        videoObserver.observe(video);
    });
}

// Ensure all DOM content is loaded before running scripts
document.addEventListener('DOMContentLoaded', function() {
    // Keep the old responsive video function
    function responsiveBlogVideos() {
        // ... (your existing code for this function)
    }
    responsiveBlogVideos();

    // Add the new function call
    setupVideoAutoplayOnScroll();
});